export const PRESET_TEAMS_TEMPLATE = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{page.title}</title>
    <link href="https://fonts.googleapis.com/css2?family=Segoe+UI:wght@400;500;600;700&display=swap" rel="stylesheet">
    <style>
        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }

        body {
            font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
            background-color: #ffffff;
            color: #242424;
            font-size: 12px;
            line-height: 1.4;
            margin: 0;
            padding: 0;
        }

        .teams-container {
            max-width: 100%;
            width: 100%;
            margin: 0 auto;
            background-color: #ffffff;
        }

        .header {
            background-color: {color.primary};
            padding: 16px 24px;
            display: flex;
            align-items: center;
            gap: 16px;
        }

        .header-logo {
            width: {logo.size}px;
            height: {logo.size}px;
            border-radius: 8px;
            background-color: {logo.background};
            padding: 6px;
            object-fit: contain;
        }

        .header-content {
            flex: 1;
        }

        .header-title {
            color: #ffffff;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 2px;
        }

        .header-subtitle {
            color: rgba(255, 255, 255, 0.9);
            font-size: 13px;
            font-weight: 400;
        }

        .user-greeting {
            padding: 20px 24px;
            border-bottom: 1px solid #e0e0e0;
        }

        .greeting-text {
            font-size: 16px;
            font-weight: 600;
            color: #242424;
            margin-bottom: 4px;
        }

        .greeting-subtext {
            font-size: 13px;
            color: #616161;
        }

        .courses-section {
            padding: 20px 24px;
        }

        .section-title {
            font-size: 14px;
            font-weight: 600;
            color: #242424;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .section-title-icon {
            width: 20px;
            height: 20px;
            color: {color.primary};
        }

        .course-count {
            background-color: {color.primary};
            color: #ffffff;
            font-size: 12px;
            font-weight: 600;
            padding: 4px 10px;
            border-radius: 12px;
            margin-left: auto;
        }

        .course-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .course-card {
            background-color: #ffffff;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            padding: 16px;
            display: flex;
            align-items: center;
            gap: 16px;
            transition: all 0.2s ease;
            cursor: pointer;
        }

        .course-card:hover {
            border-color: {color.primary};
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .course-icon {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            background-color: {color.primary};
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .course-icon svg {
            width: 24px;
            height: 24px;
            fill: #ffffff;
        }

        .course-details {
            flex: 1;
            min-width: 0;
        }

        .course-name {
            font-size: 15px;
            font-weight: 600;
            color: #242424;
            margin-bottom: 4px;
        }

        .course-meta {
            display: flex;
            align-items: center;
            gap: 16px;
            font-size: 13px;
            color: #616161;
        }

        .course-meta-item {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .course-meta-icon {
            width: 14px;
            height: 14px;
            fill: #616161;
        }

        .course-status {
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            flex-shrink: 0;
        }

        .status-pending {
            background-color: #fff4ce;
            color: #8a6914;
        }

        .status-overdue {
            background-color: #fde7e9;
            color: #c42b1c;
        }

        .status-new {
            background-color: #e6f2ff;
            color: #0067b8;
        }

        .course-action {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: {color.primary};
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            transition: all 0.2s ease;
        }

        .course-action:hover {
            transform: scale(1.1);
        }

        .course-action svg {
            width: 16px;
            height: 16px;
            fill: #ffffff;
        }

        .empty-state {
            text-align: center;
            padding: 48px 24px;
        }

        .empty-state-icon {
            width: 64px;
            height: 64px;
            margin: 0 auto 16px;
            fill: #e0e0e0;
        }

        .empty-state-text {
            font-size: 14px;
            color: #616161;
        }

        .footer {
            padding: 20px 24px;
            border-top: 1px solid #e0e0e0;
            text-align: center;
        }

        .footer-text {
            font-size: 12px;
            color: #8a8a8a;
        }

        .footer-link {
            color: {color.primary};
            text-decoration: none;
            font-weight: 500;
        }

        .footer-link:hover {
            text-decoration: underline;
        }

        .pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #e0e0e0;
        }

        .pagination-btn {
            width: 32px;
            height: 32px;
            border: 1px solid #e0e0e0;
            background-color: #ffffff;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
        }

        .pagination-btn:hover:not(:disabled) {
            border-color: {color.primary};
            background-color: #f5f5f5;
        }

        .pagination-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .pagination-btn svg {
            width: 16px;
            height: 16px;
            fill: #616161;
        }

        .pagination-info {
            font-size: 13px;
            color: #616161;
            min-width: 80px;
            text-align: center;
        }
    </style>
</head>
<body>
    <div class="teams-container">
        <div class="header">
            <img src="{client.logo}" alt="Company Logo" class="header-logo">
            <div class="header-content">
                <div class="header-title">{header.title}</div>
                <div class="header-subtitle">{header.subtitle}</div>
            </div>
        </div>

        <div class="user-greeting">
            <div class="greeting-text">Hi {user.name},</div>
            <div class="greeting-subtext">{greeting.message}</div>
        </div>

        <div class="courses-section">
            <div class="section-title">
                <svg class="section-title-icon" viewBox="0 0 18 16">
                    <path d="M17.5088 1.89875V12.3025C17.5088 13.1512 16.8175 13.93 15.9688 14.035L15.6975 14.07C14.2625 14.2625 12.2413 14.8575 10.6138 15.54C10.045 15.7762 9.41504 15.3475 9.41504 14.7262V2.555C9.41504 2.23125 9.59879 1.93375 9.88754 1.77625C11.4888 0.91 13.9125 0.14 15.5575 0H15.61C16.66 0 17.5088 0.84875 17.5088 1.89875Z" fill="currentColor"/>
                    <path d="M7.63 1.77625C6.02875 0.91 3.605 0.14 1.96 0H1.89875C0.84875 0 0 0.84875 0 1.89875V12.3025C0 13.1512 0.69125 13.93 1.54 14.035L1.81125 14.07C3.24625 14.2625 5.2675 14.8575 6.895 15.54C7.46375 15.7762 8.09375 15.3475 8.09375 14.7262V2.555C8.09375 2.2225 7.91875 1.93375 7.63 1.77625ZM2.63375 4.4275H4.6025C4.96125 4.4275 5.25875 4.725 5.25875 5.08375C5.25875 5.45125 4.96125 5.74 4.6025 5.74H2.63375C2.275 5.74 1.9775 5.45125 1.9775 5.08375C1.9775 4.725 2.275 4.4275 2.63375 4.4275ZM5.25875 8.365H2.63375C2.275 8.365 1.9775 8.07625 1.9775 7.70875C1.9775 7.35 2.275 7.0525 2.63375 7.0525H5.25875C5.6175 7.0525 5.915 7.35 5.915 7.70875C5.915 8.07625 5.6175 8.365 5.25875 8.365Z" fill="currentColor"/>
                </svg>
                {section.title}
                <span class="course-count">{course.count}</span>
            </div>

            <div class="course-list" id="courseList">
                {course.list}
            </div>

            <div class="pagination" id="pagination" style="display: {pagination.display};">
                <button class="pagination-btn" id="prevBtn" onclick="prevPage()">
                    <svg viewBox="0 0 24 24">
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                    </svg>
                </button>
                <span class="pagination-info" id="pageInfo">Page 1 of {pagination.totalPages}</span>
                <button class="pagination-btn" id="nextBtn" onclick="nextPage()">
                    <svg viewBox="0 0 24 24">
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="footer">
            <p class="footer-text">{footer.text}</p>
        </div>
    </div>

    <script>
        const COURSES_PER_PAGE = 5;
        const allCourses = {courses.json};
        let currentPage = 1;
        const totalPages = Math.ceil(allCourses.length / COURSES_PER_PAGE);

        function renderCourses() {
            const start = (currentPage - 1) * COURSES_PER_PAGE;
            const end = start + COURSES_PER_PAGE;
            const pageCourses = allCourses.slice(start, end);

            const courseList = document.getElementById('courseList');
            courseList.innerHTML = pageCourses.map(course => \`
                <div class="course-card" onclick="selectCourse('\${course.id}')">
                    <div class="course-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
                        </svg>
                    </div>
                    <div class="course-details">
                        <div class="course-name">\${course.name}</div>
                        <div class="course-meta">
                            <span class="course-meta-item">
                                <svg class="course-meta-icon" viewBox="0 0 24 24">
                                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
                                </svg>
                                Added \${course.dateAdded}
                            </span>
                        </div>
                    </div>
                    <div class="course-action">
                        <svg viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z"/>
                        </svg>
                    </div>
                </div>
            \`).join('');

            document.getElementById('pageInfo').textContent = \`Page \${currentPage} of \${totalPages}\`;
            document.getElementById('prevBtn').disabled = currentPage === 1;
            document.getElementById('nextBtn').disabled = currentPage === totalPages;
        }

        function nextPage() {
            if (currentPage < totalPages) {
                currentPage++;
                renderCourses();
            }
        }

        function prevPage() {
            if (currentPage > 1) {
                currentPage--;
                renderCourses();
            }
        }

        function selectCourse(courseId) {
            const course = allCourses.find(c => c.id === courseId);
            if (course && course.coursePath) {
                const baseUrl = '{app.url}';
                const courseUrl = baseUrl + '/' + course.coursePath;
                // Open in scorm-wrapper.html (not teams) to play the course
                const wrapperUrl = baseUrl + '/scorm-wrapper.html' +
                    '?courseUrl=' + encodeURIComponent(courseUrl) +
                    '&emailAddress=' + encodeURIComponent(course.emailAddress || '') +
                    '&courseIdentifier=LMS' +
                    '&courseType=' + (course.isXApi ? 'xapi' : 'scorm');

                // Open course in new tab (nested iframes from srcDoc can't load external URLs)
                window.open(wrapperUrl, '_blank');
            }
        }

        function showCoursePlayer(wrapperUrl, courseName) {
            // Hide the course list and show the course player
            document.querySelector('.courses-section').style.display = 'none';
            document.querySelector('.user-greeting').style.display = 'none';

            // Create course player container if it doesn't exist
            let playerContainer = document.getElementById('course-player-container');
            if (!playerContainer) {
                playerContainer = document.createElement('div');
                playerContainer.id = 'course-player-container';
                playerContainer.style.cssText = 'display: flex; flex-direction: column; height: calc(100vh - 120px); padding: 0;';
                document.querySelector('.teams-container').insertBefore(playerContainer, document.querySelector('.footer'));
            }

            playerContainer.innerHTML = \`
                <div style="display: flex; align-items: center; padding: 12px 24px; border-bottom: 1px solid #e0e0e0; background: #f5f5f5;">
                    <button onclick="backToCourseList()" style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; border: 1px solid #e0e0e0; border-radius: 4px; background: #fff; cursor: pointer; font-size: 14px;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#616161">
                            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                        </svg>
                        Back to Courses
                    </button>
                    <span style="margin-left: 16px; font-weight: 600; color: #242424;">\${courseName}</span>
                </div>
                <iframe src="\${wrapperUrl}" style="flex: 1; border: none; width: 100%;" allowfullscreen></iframe>
            \`;
            playerContainer.style.display = 'flex';
        }

        function backToCourseList() {
            // Show course list, hide player
            document.querySelector('.courses-section').style.display = 'block';
            document.querySelector('.user-greeting').style.display = 'block';
            const playerContainer = document.getElementById('course-player-container');
            if (playerContainer) {
                playerContainer.style.display = 'none';
                playerContainer.innerHTML = '';
            }
        }

        // Initial render
        if (allCourses.length > COURSES_PER_PAGE) {
            renderCourses();
        }
    </script>
</body>
</html>
`;

export const TEAMS_COURSE_CARD_TEMPLATE = `
<div class="course-card" onclick="selectCourse('{course.id}')">
    <div class="course-icon">
        <svg viewBox="0 0 24 24">
            <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
        </svg>
    </div>
    <div class="course-details">
        <div class="course-name">{course.name}</div>
        <div class="course-meta">
            <span class="course-meta-item">
                <svg class="course-meta-icon" viewBox="0 0 24 24">
                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
                </svg>
                Added {course.dateAdded}
            </span>
        </div>
    </div>
    <span class="course-status {course.statusClass}">{course.status}</span>
    <div class="course-action">
        <svg viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z"/>
        </svg>
    </div>
</div>
`;

export const TEAMS_EMPTY_STATE_TEMPLATE = `
<div class="empty-state">
    <svg class="empty-state-icon" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
    <p class="empty-state-text">You're all caught up! No pending courses.</p>
</div>
`;
